function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "\n    org-post\n  ");

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20,13.4H12.65a1.25,1.25,0,0,1,0-2.5H20a1.25,1.25,0,0,1,0,2.5Z",
  fill: "#737476"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M25.52,18.92H12.65a1.25,1.25,0,1,1,0-2.5H25.52a1.25,1.25,0,0,1,0,2.5Z",
  fill: "#737476"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M25.52,24.43H12.65a1.25,1.25,0,1,1,0-2.5H25.52a1.25,1.25,0,1,1,0,2.5Z",
  fill: "#737476"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M20,30H12.65a1.25,1.25,0,0,1,0-2.5H20A1.25,1.25,0,0,1,20,30Z",
  fill: "#737476"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M24.17,12a1.28,1.28,0,0,1-.89-.36,1.25,1.25,0,0,1,0-1.77l7.33-7.33A1.25,1.25,0,0,1,32.38,4.3l-7.33,7.33A1.24,1.24,0,0,1,24.17,12Z",
  fill: "#737476"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M32,10.7a1.25,1.25,0,0,1-1.25-1.25V4.17H25.52a1.25,1.25,0,0,1,0-2.5H32a1.25,1.25,0,0,1,1.25,1.25V9.45A1.25,1.25,0,0,1,32,10.7Z",
  fill: "#737476"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M30.1,37.27H7.87A1.25,1.25,0,0,1,6.62,36V4.81A1.25,1.25,0,0,1,7.87,3.56H19.52a1.25,1.25,0,1,1,0,2.5H9.12V34.77H28.85V14.91a1.25,1.25,0,0,1,2.5,0V36A1.25,1.25,0,0,1,30.1,37.27Z",
  fill: "#737476"
});

function SvgOrgPost(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 40 40"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

export default SvgOrgPost;